import { REPORTS_NAMESPACE_TRANSLATIONS } from "./reports-namespace-translations.ts"
import { REPORTS_TRANSLATIONS } from "./reports-translations.ts"
import { COW_STATUS_TRANSLATIONS } from "@/locales/en/cow-status-translations.ts"
import { EN_MAIN_TRANSLATIONS } from "@/locales/en/main-translations.ts"

export const EN_TRANSLATIONS = {
  translation: {
    ...EN_MAIN_TRANSLATIONS,
    ...REPORTS_TRANSLATIONS,
  },
  cowStatus: {
    ...COW_STATUS_TRANSLATIONS,
  },
  reports: { ...REPORTS_NAMESPACE_TRANSLATIONS },
}
